/**
 * @type {Object}
 * @property {array}  data  User
 */
const initialState = {
    notifications: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerNotifications = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_NOTIFICATIONS':
            var { data } = action;
            newState.notifications = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerNotifications;